import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import EditIcon from '@material-ui/icons/Edit';
import { createMuiTheme, MuiThemeProvider, Switch, TableCell, Typography, withStyles, Grid, Button, ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from "@material-ui/core";
import AddPasien from '../MasterData/addPasien';
import AddDocter from '../MasterData/addDocter';
import DetailDocter from '../MasterData/detailDocter';
import FilterDocter from '../MasterData/filterDokter';
import { getDocter } from '../../store/actions/dokterAction';
import { useDispatch, useSelector } from 'react-redux';
import editIcon from '../../assets/ic_detail.png';
import print from '../../assets/ic_print.png';
import api from '../api';
import { useHistory } from 'react-router';
import download from '../../assets/ic_downloadFile.png';
import EditReservasiCode from './editReservasiCode';
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const IconSwitch = withStyles((theme) => ({
    root: {
        width: 36,
        height: 20,
        padding: 0,
        margin: theme.spacing(0),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 20,
        height: 20,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

const optionsFacility = [
    "Tagihan Non Reservasi",
    "Farmasi",
    "Laboratorium",
    "Radiologi"
];


export default function Pembayaran(props) {
    const history = useHistory()
    const [visibleCreate, setVisibleCreate] = React.useState(false);
    const [visibleFilter, setVisibleFilter] = React.useState(false);
    const [visibleDetail, setVisibleDetail] = React.useState(false);
    const [visibleTagihan, setVisibleTagihan] = useState(false)
    const [popUpKode, setPopUpKode] = useState(false)
    const [data, setData] = React.useState([])
    const [detail, setDetail] = React.useState([])
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);

    const handleClick = () => {
        console.info(`You clicked ${optionsFacility[selectedIndex]}`);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        if (String(optionsFacility[index]).includes("Farmasi")) {
            console.log("ini farmasi");
            history.push({
                pathname: '/pembayaran/detail-tagihan-non-reservasi-farmasi',
                name: 'Pembayaran Farmasi - Input Tagihan Tanpa Reservasi',
                search: '',  // query string
                // state: {  // location state
                //     intent: "nonReservasi"
                // },
            })
        } else if (String(optionsFacility[index]).includes("Laboratorium")) {
            console.log("ini Laboratorium");
            history.push({
                pathname: '/pembayaran/detail-tagihan-non-reservasi-lab',
                name: 'Pembayaran Laboratorium - Input Tagihan Tanpa Reservasi',
                search: '',  // query string
                // state: {  // location state
                //     intent: "nonReservasi"
                // },
            })
        } else {
            console.log("ini Radiologi");
            history.push({
                pathname: '/pembayaran/detail-tagihan-non-reservasi-radiologi',
                name: 'Pembayaran Radiologi - Input Tagihan Tanpa Reservasi',
                search: '',  // query string
                // state: {  // location state
                //     intent: "nonReservasi"
                // },
            })
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    useEffect(() => {
        getData()
        getParam()
    }, [])

    const getParam = () => {
        api.create().getParameter().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    response.data.data.map((item) => {
                        if (item.param_code === "BILL") {
                            if (item.param_value === "false") {
                                setVisibleTagihan(false)
                            } else {
                                setVisibleTagihan(true)
                            }

                        }
                    })
                }
            }
        })
    }

    const getData = () => {
        api.create().getPembayaran().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let temp = []
                    response.data.data && response.data.data.map(el => {
                        if (el.online_payment_status !== "Available" || el.his_payment_status !== "Available") {
                            let reference = []
                            if (el.type_code && el.type_code.length > 0) {
                                el.type_code.map((item) => {
                                    reference.push(item)
                                })
                            }
                            temp.push({
                                kodeTransaksi: el.transaction_code_medapp,
                                tgl: el.transaction_date,
                                referensi: reference.join(", "),
                                rekamMedis: el.patient_mr_no,
                                namaPasien: el.patient_name === null ? el.bill_owner : el.patient_name,
                                kodeReservasi: el.booking_code,
                                gender : el.patient_gender === "P" ? "Perempuan" : "Laki-laki",
                                statusOnline: el.payment_status,
                                statusHis: el.bill_status,
                                tglTagihan: el.payment_date,
                                id: el.id
                            })
                        }
                    })
                    console.log(temp);
                    setData(temp)
                }
            }
        })
    }

    const columns = [
        {
            name: "kodeTransaksi",
            label: "Kode Transaksi",
            options: {
                sortThirdClickReset: true,
            }
        },
        {
            name: "tgl",
            label: "Tanggal Transaksi",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "referensi",
            label: "No Referensi",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "rekamMedis",
            label: "No Rekam Medis",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "namaPasien",
            label: "Nama Pasien",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "kodeReservasi",
            label: "Kode Reservasi",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "gender",
            label: "Jenis Kelamin",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "statusOnline",
            label: "Status Pembayaran Online",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "statusHis",
            label: "Status Pembayaran HIS",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "tglTagihan",
            label: "Tanggal Pembayaran",
            options: {
                sortThirdClickReset: true
            }
        },
        {
            name: "Aksi",
            options: {
                sort: false,
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div style={{ display: 'flex', justifyContent: 'center', placeContent: 'center' }}>
                            <button
                                title="Edit"
                                onClick={() => handleSeeDetail(tableMeta)}
                                style={{
                                    backgroundColor: "transparent",
                                    fontSize: 20,
                                    outline: 'none',
                                    borderColor: 'transparent',
                                    marginRight: 20
                                }}>
                                <img src={editIcon} style={{ width: 30, height: 30 }} />
                            </button>
                            {/* <div
                                style={{ width: 29, height: 29, borderRadius: 90, backgroundColor: '#65ae92', alignSelf: 'center', cursor: 'pointer' }}
                                onClick={() => doPrint()}
                                title="Print"
                            >
                                <img src={print} style={{ marginLeft: 5, marginTop: 6 }} />

                            </div> */}
                        </div>
                    )
                }
            }
        },
        {
            name: "id",
            options: {
                display: false,
                filter: false
            }
        }];

    const doPrint = () => {

    }

    // const options = {
    //     filterType: 'checkbox',
    //     // pagination: false,
    //     filter: false,
    //     sort: false,
    //     print: false,
    //     download: false,
    //     selectableRows: false,
    //     viewColumns: false,
    //     search: false,
    //     rowsPerPage: 10,
    //     responsive: 'scrollMaxHeight',
    // };

    const onOpen = () => {
        setVisibleCreate(true);
    };

    const onClose = () => {
        setVisibleCreate(false);
        setVisibleFilter(false);
        setVisibleDetail(false)
    };

    const handleSeeDetail = ({ rowData }) => {
        console.log(rowData);
        const id = rowData[rowData.length - 1]
        console.log(id);
        api.create().getPembayaranDetail(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    const sentData = response.data.data
                    history.push({
                        pathname: '/pembayaran/detail-monitoring',
                        name: 'Detail Pembayaran',
                        state: {
                            data: rowData,
                            height: props.height
                        }
                    })
                }
            }
        })
    };

    return (
        <div style={{ paddingTop: 10, position: 'relative' }}>
            {visibleTagihan && (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '40%', position: 'absolute', left: 10, top: 15, zIndex: '10' }}>
                        <button style={{ height: 35, padding: 3, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                            onClick={() => setPopUpKode(true)}
                        >
                            <div style={{ display: 'flex' }}>
                                <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tagihan Baru</Typography>
                            </div>
                        </button>
                    </div>
                    <div style={{ width: '40%', position: 'absolute', left: 160, top: 15, zIndex: '10' }}>
                        <Grid item xs={12}>
                            <ButtonGroup
                                style={{
                                    backgroundColor: "#2a9c6c",
                                    color: "white",
                                    borderRadius: 20,
                                    boxShadow: "5px 2px 10px 0 #999999",
                                    borderColor: "transparent",
                                    outline: "none"
                                }}
                                variant="contained"
                                ref={anchorRef}
                                aria-label="split button"
                            >
                                <Button
                                    style={{
                                        backgroundColor: "#2a9c6c",
                                        color: "white",
                                        borderTopLeftRadius: 20,
                                        borderBottomLeftRadius: 20,
                                        boxShadow: "5px 2px 10px 0 #999999",
                                        borderColor: "transparent",
                                        outline: "none",
                                        textTransform: "capitalize",
                                        fontSize: 13,
                                        fontFamily: 'Poppins',
                                        fontWeight: '400',
                                        paddingRight: 0
                                    }}
                                    onClick={handleToggle}
                                >
                                    {optionsFacility[selectedIndex]}
                                </Button>
                                <Button
                                    style={{
                                        boxShadow: "5px 2px 10px 0 #999999",
                                        backgroundColor: "#2a9c6c",
                                        borderTopRightRadius: 20,
                                        borderBottomRightRadius: 20,
                                        borderColor: "transparent",
                                        outline: "none",
                                        zIndex: '1000'
                                    }}
                                    color="secondary"
                                    size="small"
                                    aria-controls={open ? "split-button-menu" : undefined}
                                    aria-expanded={open ? "true" : undefined}
                                    aria-label="select merge strategy"
                                    aria-haspopup="menu"
                                    onClick={handleToggle}
                                >
                                    <ArrowDropDownIcon />
                                </Button>
                            </ButtonGroup>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{
                                            transformOrigin:
                                                placement === "bottom" ? "center top" : "center bottom"
                                        }}
                                    >
                                        <Paper>
                                            <ClickAwayListener onClickAway={handleClose}>
                                                <MenuList id="split-button-menu">
                                                    {optionsFacility.map((option, index) => (
                                                        <MenuItem
                                                            key={option}
                                                            disabled={index === 0}
                                                            selected={index === selectedIndex}
                                                            onClick={(event) => handleMenuItemClick(event, index)}
                                                        >
                                                            {option}
                                                        </MenuItem>
                                                    ))}
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </Grid>
                        {/* <button style={{ height: 35, padding: 3, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', borderColor: 'transparent', outline: 'none' }}
                            onClick={() =>
                                history.push({
                                    pathname: '/pembayaran/detail-tagihan-non-reservasi',
                                    name: 'Pembayaran - Input Tagihan Tanpa Reservasi',
                                    search: '',  // query string
                                    // state: {  // location state
                                    //     intent: "nonReservasi"
                                    // },
                                })
                            }
                        >
                            <div style={{ display: 'flex' }}>
                                <img style={{ margin: 'auto', width: 25, marginTop: 0, marginRight: 5 }} src="https://img.icons8.com/flat_round/50/000000/plus.png" />
                                <Typography style={{ fontSize: 13, margin: 'auto', marginRight: 8, color: 'white' }}>Tagihan Non Reservasi</Typography>
                            </div>
                        </button> */}
                    </div>
                </div>

            )}
            <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={data}
                        columns={columns}
                        options={options}
                    />
                </MuiThemeProvider>

            </div>
            {/* <div style={{ marginTop: 20, boxShadow: '5px 2px 10px 0 #999999', borderRadius: 30 }}> */}
            {/* </div> */}

            {visibleCreate ?
                <AddDocter
                    onClose={onClose}
                /> : null}

            {visibleFilter ?
                <FilterDocter
                    onClose={onClose} /> : null}

            {popUpKode && (
                <EditReservasiCode
                    onClose={() => setPopUpKode(false)}
                    intent="list"
                />
            )}
        </div>
    )
}